import React from "react";
import { AppColumn, AppRow } from "../Layouts"
import { Icon } from "semantic-ui-react";
import useTheme from "../../../hooks/useTheme";
import { useResponsive } from "../ResponsiveContext";
import AppText from "../Texts/AppTexts";
import { SizedBox } from "../Sizes";

import { WorkplaceLogo } from "../DisplayImage";

const AppWorkplaceCard = ({ workplaceData, onClick, type = 'search' }) => {
    const { isMobile } = useResponsive();
    const theme = useTheme();

    const isSearchType = type === 'search';
    const isNormal = type === 'normal';

    return (<AppRow
        crossAxisAlignment={"start"}
        mainAxisAlignment={"space-between"}
        key={workplaceData['ivo_id_obj']}
        onClick={onClick}
        style={{
            marginBottom: theme.spacing.elementPadding,
            cursor: onClick && 'pointer',
            padding: isNormal ? theme.spacing.elementPadding : theme.spacing.elementPaddingSmall,
            backgroundColor: isNormal && '#F1F1F1',
            borderRadius: theme.radius.default,

        }}
    >
        <AppRow crossAxisAlignment={isNormal ? "center" : "start"} mainAxisAlignment={"start"}>
            <div style={{
                marginTop: '0.25rem',
            }}>
                <WorkplaceLogo
                    url={workplaceData['logoUrl']}
                    style={{
                        height: isMobile ? '40px' : '54px',
                        width: isMobile ? '40px' : '54px',
                    }}
                />
            </div>
            <SizedBox width={theme.spacing.elementPadding} />
            <AppColumn crossAxisAlignment={'start'} >
                <AppText.Caption fontWeight={600} color={theme.primaryColor}>
                    {workplaceData['name_obj']}
                </AppText.Caption>
                <SizedBox height={'0.15rem'} />

                {workplaceData['org_name'] && (<AppColumn>
                    <SizedBox height={'0.25rem'} />

                    <AppText.Footnote>
                        {workplaceData['org_name']}
                    </AppText.Footnote>
                </AppColumn>)}

                {isSearchType && (
                    <AppColumn>
                        {workplaceData['name_verksamhet'] && (<AppColumn>
                            <SizedBox height={'0.25rem'} />

                            <AppText.Footnote>
                                {workplaceData['name_verksamhet']}
                            </AppText.Footnote>
                        </AppColumn>)}

                        {workplaceData['adress_obj'] && (<AppColumn>
                            <SizedBox height={'0.25rem'} />

                            <AppText.Footnote>
                                {workplaceData['adress_obj']}
                            </AppText.Footnote>
                        </AppColumn>)}
                    </AppColumn>
                )}

            </AppColumn>
        </AppRow>
        {!isNormal && <Icon
            name="circle outline"
            style={{
                marginTop: '0.5rem',
                fontSize: '1.2rem',
                color: theme.colors.grey,
            }}
        />}
    </AppRow>)
}

export default AppWorkplaceCard;